<script setup>
import { ref } from 'vue';
import { useCifraClient } from '@/api/cifra-client';
import SelectorNumerico from '../../../components/inputs/SelectorNumerico.vue';
import { animateCSS } from '../../../libs/animate';

const { cifraClient } = useCifraClient();

const props = defineProps({
  idTienda: { type: Number, required: true },
  idProducto: { type: Number, required: true },
  idProductoLote: { type: Number, required: true },
  modelValue: { type: Number, default: 1 },
});

const modelInterno = ref(props.modelValue);
const selector = ref();

function actualizarUnidades(valor) {
  const data = {
    producto_lote: {
      unidades: valor,
    },
  };
  cifraClient.post(
    `/tiendas/admin/${props.idTienda}/productos/${props.idProducto}/productos_lotes/${props.idProductoLote}/actualizar_unidades`,
    data,
  ).then(() => {
    animateCSS(selector.value.$el, 'pulse');
  });
}

</script>

<template>
  <SelectorNumerico
    ref="selector"
    v-model="modelInterno"
    name="unidades"
    size="sm"
    :min="1"
    :max="999"
    @update:model-value="actualizarUnidades"
  />
</template>
